import React from 'react'
import './headers.css'
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'

const Credentials = () => {
  return (
    <header>
    <div className="container header__container">
      <h2>Hello, I'm</h2>
      <h1>Ousmane Sangary</h1>
      <h3 className='text-light'>A software Engineer based in China, 
        and I'm very passionate and dedicated to my work. </h3>
      <h3>Currently pursuing my Master's degree in Computer Science.</h3>
      {/* <h5 className='text-light'>
        I'm a software Engineer based in China, 
        and I'm very passionate and dedicated to my work.
      </h5> */}
      <CTA />
      {/* <HeaderSocials /> */}
       {/* 2:16:17 */}
      {/* <div className="me">
        <img src={DEMO} alt="" />
      </div> */}

      {/* <a href="#contact" className='scroll_down'>The completion of your project is my challange</a> */}
    </div>
   </header>
  )
}

export default Credentials